// firebase.js — the single place Firebase is initialised.
// Every other module imports { app, auth, db } from here; never call
// initializeApp / getAuth / getFirestore anywhere else.

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  initializeAuth,
  getAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  browserPopupRedirectResolver
} from "firebase/auth";

// Web API keys are public identifiers, not secrets; access is controlled
// by Firestore security rules and Auth settings, not by hiding this config.
const firebaseConfig = {
  apiKey: "AIzaSyDDzM0KUZwxrGr24E8-zrsjIcKG8N-0Ioo",
  authDomain: "decidebetterdaily-fd670.firebaseapp.com",
  projectId: "decidebetterdaily-fd670",
  storageBucket: "decidebetterdaily-fd670.appspot.com",
  messagingSenderId: "119947082048",
  appId: "1:119947082048:web:2792b5d63bc7f9d2df22a5",
  measurementId: "G-GJDZRT008G"
};

export const app = initializeApp(firebaseConfig);

// --- App Check -------------------------------------------------------------
// Proves to Firebase that requests come from this site (reCAPTCHA v3, invisible).
// Set APP_CHECK_SITE_KEY from Firebase console → App Check → Web app → reCAPTCHA v3.
// Leave it empty to run without App Check. On localhost a debug token is used;
// register the token the console prints under App Check → "Manage debug tokens".
const APP_CHECK_SITE_KEY = "";
if (APP_CHECK_SITE_KEY) {
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  import("firebase/app-check").then(({ initializeAppCheck, ReCaptchaV3Provider }) => {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(APP_CHECK_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });
  }).catch(e => console.warn('App Check not initialised:', e));
}

export const db = getFirestore(app);

// Explicit persistence order so Safari / iOS / Arc fall back gracefully
// when IndexedDB is unavailable. popupRedirectResolver is required for
// signInWithPopup / signInWithRedirect when auth is initialised this way.
let _auth;
try {
  _auth = initializeAuth(app, {
    persistence: [
      indexedDBLocalPersistence,
      browserLocalPersistence,
      browserSessionPersistence
    ],
    popupRedirectResolver: browserPopupRedirectResolver
  });
} catch (e) {
  // Only reachable if something else initialised auth first.
  console.warn("Auth already initialised; using existing instance.", e);
  _auth = getAuth(app);
}
export const auth = _auth;
